import { Navigate, Outlet } from "react-router";
import { CREATE, MODIFY, ROLE, useFoodpilotContext } from "src/context/FoodpilotContext";

export const PermissionsProtection = () => {
    const { canUser } = useFoodpilotContext();
    const canViewPermissions = canUser(CREATE, ROLE) || canUser(MODIFY, ROLE);

    if (!canViewPermissions) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
